import { render, staticRenderFns } from "./CommonQuestion.vue?vue&type=template&id=1e13b634&scoped=true&"
import script from "./CommonQuestion.vue?vue&type=script&lang=js&"
export * from "./CommonQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CommonQuestion.vue?vue&type=style&index=0&id=1e13b634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e13b634",
  null
  
)

export default component.exports